module.exports = __webpack_public_path__ + "static/media/many-people-solid.28ce2aca.svg";